'use strict';
var React = require('react');
var ScrollBox = require('osx-scrollview');
var styleHelper = require('../../helper/styleHelper');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 内容面板中的滚动区
 */
var ScrollArea = React.createClass({
  render: function () {
    var content = this.props.items[0];
    var dom =
      (<div key={this.props.controlID}
            className="component component-scrollarea"
            style={{
              left : 0,
              top : 0,
              width : '100%',
              height : '100%',
              backgroundColor : styleHelper.getBackgroundColor(this.props),
              borderStyle:'none'
            }}
            onScroll={this._onMouseWheel}
      >
        <ScrollBox disableHScroll={!this.props.canHoriScroll}
                   disableVScroll={!this.props.canVertScroll}>
          <div key="viewPort" style={{
            width : this.props.viewPortSize?this.props.viewPortSize.w + 20:styleHelper.getWidth(this.props),//补偿滚动条的宽度 // FIXME: viewPortSize 可能为 undefined
            height : this.props.viewPortSize?this.props.viewPortSize.h + 20:styleHelper.getHeight(this.props),
            overflow : 'hidden'
          }}>
            {this.props.children}
          </div>
        </ScrollBox>
      </div>);
    return dom;
  },

  _onMouseWheel : function(e){
    e.stopPropagation();
  }
});

module.exports = ScrollArea;



// WEBPACK FOOTER //
// ./src/views/Components/ScrollArea.jsx